import { APP_ENV } from './central-api';

// export const HOME_ROUTE = '/dashboard';
export const HOME_ROUTE = '/tara';
// export const HOME_ROUTE = '/integrations';

// visibility of routes based on environment
const routeVisibility = {
  DEV: {
    // Top Level
    '/dashboard': true,
    '/tracking': true,
    '/settings': true,
    '/clients': true,

    // Tara
    '/tara': true,
    '/tara/search': true,

    // Integrations (MCP)
    '/integrations': true,

    // Tracking
    '/tracking/trends': true,
    '/tracking/css': true,
    '/tracking/integration': true,
    '/tracking/autofill': false,
    '/tracking/events': true,

    //reports
    '/reports': true,
    '/reports/notifications': true,
    '/reports/presentations': true,
    '/reports/prompts': true,
    '/reports/graphs': true,

    //ai-optimizations
    '/ai-optimizations': true,
    '/ai-optimizations/automated': true,
    '/ai-optimizations/manual': true,

    // Recommendations
    '/recommendations': false,

    // Actions
    '/actions': true,
    '/actions/queue': true,
    '/actions/history': true,
    '/actions/settings': true,
    '/actions/rules': true,

    // Settings
    '/settings/general': true,
    '/settings/subscription': true,
    '/settings/profile': true,
    '/settings/api-keys': true,
    '/settings/tara': true,
    '/settings/appearance': false,
    '/settings/payments': false,
    '/settings/shipping': false,
    '/settings/convenienceFee': false,
    '/settings/discounts': false,
    '/settings/notifications': false,
    '/settings/webhooks': false,
    '/settings/marketing': false,
    '/settings/security': false,
    '/settings/communication': true,
    '/settings/brand': true,

    // Payments
    '/settings/payments/connection': true,
    '/settings/payments/options': true,
  },
  STAGING: {
    // Top Level
    '/dashboard': true,
    '/tracking': true,
    '/settings': true,
    '/clients': true,

    // Tara
    '/tara': true,
    '/tara/search': true,

    // Integrations (MCP)
    '/integrations': true,

    // Tracking
    '/tracking/trends': true,
    '/tracking/css': true,
    '/tracking/integration': true,
    '/tracking/autofill': false,
    '/tracking/events': true,

    //reports
    '/reports': true,
    '/reports/notifications': true,
    '/reports/presentations': true,
    '/reports/prompts': true,
    '/reports/graphs': true,

    //ai-optimizations
    '/ai-optimizations': true,
    '/ai-optimizations/automated': true,
    '/ai-optimizations/manual': true,

    // Recommendations
    '/recommendations': false,

    // Actions
    '/actions': true,
    '/actions/queue': true,
    '/actions/history': true,
    '/actions/settings': true,
    '/actions/rules': true,

    // Settings
    '/settings/general': true,
    '/settings/subscription': true,
    '/settings/profile': true,
    '/settings/api-keys': true,
    '/settings/tara': false,
    '/settings/appearance': false,
    '/settings/payments': false,
    '/settings/shipping': false,
    '/settings/convenienceFee': false,
    '/settings/discounts': false,
    '/settings/notifications': false,
    '/settings/webhooks': false,
    '/settings/marketing': false,
    '/settings/security': false,
    '/settings/communication': true,
    '/settings/brand': true,

    // Payments
    '/settings/payments/connection': true,
    '/settings/payments/options': true,
  },
  LIVE: {
    // Top Level
    '/dashboard': true,
    '/tracking': true,
    '/settings': true,
    '/clients': true,

    // Tara
    '/tara': true,
    '/tara/search': true,

    // Integrations (MCP)
    '/integrations': true,

    // Tracking
    '/tracking/trends': true,
    '/tracking/css': true,
    '/tracking/integration': true,
    '/tracking/autofill': false,
    '/tracking/events': true,

    //reports
    '/reports': true,
    '/reports/notifications': true,
    '/reports/presentations': true,
    '/reports/prompts': true,
    '/reports/graphs': true,

    //ai-optimizations
    '/ai-optimizations': true,
    '/ai-optimizations/automated': true,
    '/ai-optimizations/manual': true,

    // Recommendations
    '/recommendations': false,

    // Actions
    '/actions': true,
    '/actions/queue': true,
    '/actions/history': true,
    '/actions/settings': true,
    '/actions/rules': true,

    // Settings
    '/settings/general': true,
    '/settings/subscription': true,
    '/settings/profile': true,
    '/settings/api-keys': true,
    '/settings/tara': false,
    '/settings/appearance': false,
    '/settings/payments': false,
    '/settings/shipping': false,
    '/settings/convenienceFee': false,
    '/settings/discounts': false,
    '/settings/notifications': false,
    '/settings/webhooks': false,
    '/settings/marketing': false,
    '/settings/security': false,
    '/settings/communication': true,
    '/settings/brand': true,

    // Payments
    '/settings/payments/connection': false,
    '/settings/payments/options': false,
  },
};

const allRoutes = routeVisibility[APP_ENV];

export { allRoutes };
